
//------------------
// Components 
//------------------

// import aura from './components/aura-canvas.js';

import { show_logo, hide_logo } from './components/logo.js';
import landing from './components/landing.js';
import asset_toggle from './components/asset-toggle.js';
import infinate_scroll from './components/infinate-scroll.js';
import load_embeds from './components/lazy-load-embed.js';
import bind_video_players from './components/bind-video-players.js';
import clients_page from './components/clients-scroll.js';
import project_overlay from './components/project-overlay.js';
import auto_scroll from './components/autoscroll.js';
import studio_text from './components/studio.js';

import cheat from './components/cheat.js';

window.his = window.location.pathname;
window.touch = isTouchDevice();

window.browser = detectBrowser();
document.body.classList.add(window.browser.replace(' ', '').toLowerCase());

function isTouchDevice() {
    return (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0));
}

window.logoShowing = false;

//------------------
// CORE 
//------------------

const menuTrig = document.querySelector('.menu-button');


window.fullscreen = 0;

var mousewheel = false;
var curScroller = false;



function half_load(){

    check_for_scroller();

    project_overlay();
    bild_ajax_load();
    load_embeds();

}

function first_load(){
    window.logoShowing = true;
    show_logo();
    bind_nav();
   
};

function page_load(){
    
    window.players = [];

    check_for_scroller();
    

    bild_ajax_load();
    landing();
    infinate_scroll();  
    load_embeds();
    clients_page();
    project_overlay();
    asset_toggle();
    bind_video_players();
    cheat();
    studio_text();
    trigger_page_view();
    
    auto_scroll();
    

};

window.onload = function(event) {
    first_load();
    page_load();
};


function bind_nav(){
    
  

    menuTrig.addEventListener('click', function(){

        if(document.body.classList.contains('nav-open')){
            show_logo();
            document.body.classList.remove('nav-open');
            menuTrig.querySelector('span').innerHTML = 'Menu';
        }else{
            document.body.classList.add('nav-open');
            hide_logo();
            menuTrig.querySelector('span').innerHTML = 'Close';
        }

    })


}


function bild_ajax_load(){

    var links = document.querySelectorAll('a:not(.bound)');

    for (let a = 0; a < links.length; a++) {
       let elm = links[a];

        if(isInternalLink(elm) && !elm.classList.contains('bound')){
            elm.classList.add('bound');
            elm.addEventListener('click', load_content);
        }
        
    }

}


window.setInterval(function(){
    bild_ajax_load();
}, 400);

const observer = new MutationObserver((mutations) => {
    mutations.forEach(() => {
      bild_ajax_load();
      check_for_scroller();
    });
});
  
observer.observe(document.body, { childList: true, subtree: true });




function load_page(full, path){

    if(full){
        window.his = path;
    }

    var cur = document.querySelector('main');
    var parent = cur.parentNode;

    if(full && cur){
        cur.style.opacity = 0;

        const overlay = document.querySelector('.project-overlay');
        if(overlay){
            overlay.style.opacity = 0;
        }
    }

    var landing = document.querySelector('.landing-wrap');
    
    if(!landing){
        document.body.classList.remove('menu-open');
    }
    
    window.history.pushState({}, '', path);

    fetch(path)
    .then(function(response) {
      return response.text();
    })
    .then(function(data) {

        document.body.classList.remove('menu-open');
        
        if(full){
            // window.scrollTo(0, 0, 'instant');
        }

        let html =  extractInnerContent(data);
        var content = html.querySelector('main');

        if(content){
            content.style.opacity = 1;
        }

        if(full){
            
            cur.parentNode.removeChild(cur);
            const overlay = document.querySelector('.project-overlay');
            if(overlay){
                overlay.parentNode.removeChild(overlay);
            }

        }else{
            content = html.querySelector('.project-overlay');
            if(!content){
                content = html.querySelector('.project-case-study');
            }
        }
        
        if(content){
            parent.append(content);
        }

        setTimeout(function(){
            if(content){
                content.style.opacity = 1;
            }
        }, 50);


        document.body.classList.remove('nav-open');
        show_logo();
        menuTrig.querySelector('span').innerHTML = 'Menu';

        if(full){
            page_load();
        }else{
            setTimeout(function(){
                half_load();
            }, 40);
        }
    })
    .catch(function(error) {
      console.error('Error:', error);
    });
    
};
  


function load_content(e){

    e.preventDefault();
    
    let elm = this;
    
    let newUrl = elm.href;
    let path = getUrlPathFromHref(newUrl);

    var full = true;

    if(elm.classList.contains('project-link')){

        full = false;

        if(document.querySelector('.project-overlay')){
            return false
        }

        if(elm.classList.contains('desktop-link') && window.touch){
            return false;
        }
    }
  
    load_page(full, path);
    
}


function isInternalLink(link) {
   
    var currentHostname = window.location.hostname;
    var linkHostname = getHostnameFromHref(link.href);

    // Compare the hostnames
    if(link.href.includes('action')){
        return false;
    }else{
        return currentHostname === linkHostname;
    }

}


  
function getHostnameFromHref(href) {

    if(href){
        var url = new URL(href);
        return url.hostname;
    }else{
        return false;
    }
}
  


  function getUrlPathFromHref(href) {
    var link = document.createElement('a');
    link.href = href;

    return link.pathname;
 
  }


function extractInnerContent(htmlString) {
    var tempElement = document.createElement('div');
    tempElement.innerHTML = htmlString;
    return tempElement;
}



function debounce(func, wait = 20, immediate = true) {
    let timeout;
    return function () {
      const context = this, args = arguments;
      const later = function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      const callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }
  


document.addEventListener('wheel', function(e) {


    if(mousewheel && e.deltaY !== 0){

        e.preventDefault();
    
        curScroller.scrollBy({
            left:e.deltaY,
            behavior: 'instant'
        });
        
    }
   

}, {passive:false} ); 


function check_for_scroller(){

    const scroller = document.querySelector('.hroz-wrap');
    const caseStudy = document.querySelector('.project-case-study');
    const projectOverlay = document.querySelector('.project-overlay');

    if(caseStudy){
        curScroller = caseStudy;
        mousewheel = false;
    }else if(projectOverlay){
        curScroller = projectOverlay;
        mousewheel = true;
    }else if(scroller){
        if(scroller.classList.contains('hroz-wrap'));
        curScroller = scroller;
        mousewheel = true;
    }else{
        curScroller = false;
        mousewheel = false;
    }

};


function isOverflowing(element) {

    return element.scrollWidth > element.offsetWidth;
  }

  window.addEventListener('popstate', function(event) {
    location.reload(true);
  });
  
  function trigger_page_view(){

    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://cabin.imagine.studio/hello.js';

    document.body.appendChild(script);

  };


  function detectBrowser() {
    const userAgent = navigator.userAgent;
    const isIOS = /iPad|iPhone|iPod/i.test(userAgent) && !window.MSStream; // Checks for iOS devices
    const isSafari = /safari/i.test(userAgent) && !/chrome|chromium|crios|edg|opr/i.test(userAgent); // Ensures it's Safari

    if (isSafari && isIOS) {
        return "iOS Safari";
    } else if (isSafari) {
        return "macOS Safari";
    } else if (/chrome|chromium|crios/i.test(userAgent)) {
        return "Google Chrome";
    } else if (/firefox|fxios/i.test(userAgent)) {
        return "Mozilla Firefox";
    } else if (/edg/i.test(userAgent)) {
        return "Microsoft Edge";
    } else if (/opr\//i.test(userAgent)) {
        return "Opera";
    } else if (/msie|trident/i.test(userAgent)) {
        return "Microsoft Internet Explorer";
    } else {
        return "Unknown Browser";
    }
}